export const xmlns = "http://www.w3.org/2000/svg";
export const xlinkns = "http://www.w3.org/1999/xlink";
export const attrs = (_el, ..._attrs) =>
    _attrs.filter(Boolean).forEach(_a => (_a.length === 3 ? _el.setAttributeNS(..._a) : _el.setAttribute(..._a)));
export const create = (_name, ..._attrs) => {
    const el = document.createElementNS(xmlns, _name);
    attrs(el, ..._attrs);
    return el;
};
